<svelte:options tag={null} />

<script lang="ts">
  import type { RatingsSize } from './ratings.types';

  export let value = 0;
  export let size: RatingsSize = 'm';
  export let a11ylabel = '';
  export let suffixlabel: string | undefined = undefined;

  $: userClass = $$props.class;
  $: attributes = { ...$$restProps };
  $: delete attributes.class;

  function getRatingsClasses(
    value: number,
    size: RatingsSize,
    suffixLabel?: string,
  ): string {
    const classes = [
      'mc-stars-result',
      `mc-stars-result--score-${computeRatingsPercentage(value)}`,
      `mc-stars-result--${size}`,
    ];

    const shouldAddFlexDisplay = !!suffixLabel;
    if (shouldAddFlexDisplay) {
      classes.push('ml-flexy', 'ml-flexy--items-center');
    }

    return classes.join(' ');
  }

  function computeRatingsPercentage(value: number): number {
    const roundedValue = Math.round(value * 2) / 2;

    let correctedValue = roundedValue;
    if (correctedValue < 0) {
      correctedValue = 0;
    }

    if (correctedValue > 5) {
      correctedValue = 5;
    }

    return correctedValue * 20;
  }
</script>

<div
  class="{getRatingsClasses(value, size, suffixlabel)} {userClass}"
  {...attributes}
>
  <span class="mc-stars-result__visual" />

  {#if suffixlabel}
    <span class="mc-stars-result__suffix-label mu-ml-050">{suffixlabel}</span>
  {/if}

  <span class="mc-stars-result__text">{a11ylabel}</span>
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/_c.stars-result';
  @import '@mozaic-ds/styles/utilities/_u.margin';
  @import '@mozaic-ds/styles/layouts/_l.flexy';

  .mc-stars-result {
    @include set-font-face();

    &--s .mc-stars-result__suffix-label {
      @include set-font-scale('02');
      color: $color-grey-700;
    }

    &--l .mc-stars-result__suffix-label {
      @include set-font-scale('06');
    }

    &--xl .mc-stars-result__suffix-label {
      @include set-font-scale('08');
    }
  }
</style>
